<template>
  <div>
    <ul v-if="item.fields">
      <li v-for="(field, fIndex) in item.fields" :key="fIndex + '-f'">
        <p>
          {{ field.name ? 'El campo "' + field.name + '"' : "" }}
          {{
            field.kind === 1
              ? "necesita ser llenado o superó el límite de caracteres"
              : ""
          }}
          {{
            field.kind === 3
              ? "necesita tener al menos un campo con el logro alcanzado especificado"
              : ""
          }}
          {{ field.kind === 4 ? "necesita tener un usuario seleccionado" : "" }}
          {{ field.kind === 5 ? "necesita tener una opción seleccionada" : "" }}
          {{
            field.kind === 6 ? "necesita tener al menos un oa seleccionado" : ""
          }}
          {{
            field.kind === 7 ? "necesita tener al menos una opción marcada" : ""
          }}
        </p>
      </li>
    </ul>
    <ul v-else>
      <li v-for="(it, iIndex) in Object.keys(item)" :key="iIndex + '-it'">
        {{ it }}
        <document-online-error-field :item="item[it]" />
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "document-online-error-field",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped></style>
